import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../services/api';
import './Register.css';
import BrandLogo from './BrandLogo';

const Register: React.FC = () => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Client-side validation
    if (formData.password !== formData.confirmPassword) {
      setError('Passwörter stimmen nicht überein');
      setLoading(false);
      return;
    }

    if (formData.password.length < 6) {
      setError('Passwort muss mindestens 6 Zeichen lang sein');
      setLoading(false);
      return;
    }

    try {
      const response = await api.post('/auth/register', formData);
      const user = response.data.user;

      // Check if email verification is required
      if (!user.emailVerified) {
        // Email verification required
        navigate('/login', {
          state: {
            message:
              'Registrierung erfolgreich! Bitte bestätige deine E-Mail-Adresse. Wir haben dir einen Bestätigungslink gesendet. Nach der Bestätigung wird dein Konto von einem Administrator aktiviert.',
          },
        });
      } else {
        // No verification required - account needs admin activation
        navigate('/login', {
          state: {
            message:
              'Registrierung erfolgreich! Dein Konto wird von einem Administrator aktiviert. Du erhältst eine Benachrichtigung, sobald dein Zugang freigeschaltet wurde.',
          },
        });
      }
    } catch (err: any) {
      setError(err.response?.data?.error || 'Registrierung fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-container">
      <div className="register-card">
        <div className="card-brand">
          <BrandLogo height={20} withIcon />
        </div>
        <h2>Registrierung</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Benutzername *</label>
            <input
              id="username"
              name="username"
              type="text"
              value={formData.username}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">E-Mail-Adresse *</label>
            <input
              id="email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Passwort *</label>
            <input
              id="password"
              name="password"
              type="password"
              value={formData.password}
              onChange={handleChange}
              required
              disabled={loading}
              minLength={6}
            />
            <small>Mindestens 6 Zeichen</small>
          </div>
          <div className="form-group">
            <label htmlFor="confirmPassword">Passwort bestätigen *</label>
            <input
              id="confirmPassword"
              name="confirmPassword"
              type="password"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </div>
          {error && <div className="error">{error}</div>}
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Wird registriert...' : 'Registrieren'}
          </button>
          <div className="register-link">
            <Link to="/login">Bereits registriert? Hier einloggen</Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Register;
